import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "homepage" */ "./BulkUploadSlider"),{
		fallback: <div>Loading...</div>
	})
};
